<template>
  <div class="">
    <TopHeader />
    <div class="ps-3 mt-3">
      <div class="general-page px-4 py-3">
        <div class="d-flex justify-content-between align-items-center">
          <div class="px-2">
            <!-- <input type="text" v-model="roleName" @focus="roleNameEmpty = false" class="role-name-input" placeholder="Role Name" /> -->
            <!-- <div v-if="roleNameEmpty" style="color: red">Role name is required</div> -->
          </div>
          <router-link class="add-role" to="/titles" title="Role">
            Back</router-link
          >
        </div>
        <div class="d-flex flex-wrap">
          <div class="mt-3 col-12 col-lg-6">
            <div class="input-box">
              <label class="mb-0" for=""> Title</label>
              <input
                v-model="title"
                @focus="titleEmpty = false"
                type="text"
                v-on:keyup.enter="update()"
              />
              <div v-if="titleEmpty" style="color: red">Title is required</div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end me-2">
          <button class="submit-btn" variant="success" @click="update()">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from "../components/TopHeader.vue";
import axios from "axios";
// @ is an alias to /src

export default {
  name: "HomeView",
  components: { TopHeader },
  data() {
    return {
      title: "",
      titleEmpty: false,
      titles: [],
    };
  },
  mounted() {
    this.getTitle();
  },
  methods: {
    async getTitle() {
      await axios
        .get(`${this.$store.getters.baseUrl}/titles/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.titles = response.data.title;
            this.title = response.data.title.title;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async update() {
      if (this.title == "") {
        this.titleEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("title", this.title);
      formdata.append("_method", "PUT");
      await axios
        .post(
          `${this.$store.getters.baseUrl}/titles/${this.$route.params.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$swal("Success", "Title Updated successfully", "success");
            this.$router.push({ name: "titles" });
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
